var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions"},[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":{name: 'market-order-detail', params: {uid: _vm.object.uid}}}},[_c('i',{staticClass:"icofont icofont-eye"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }